import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { OrderStatusResponse } from '../model/types';


export const useGetOrderStatus = (orderNumber: string | undefined) => {
    return useQuery<OrderStatusResponse, Error>({
        queryKey: ['orderStatus', orderNumber],
        queryFn: async () => {
            const { data } = await axios.get<OrderStatusResponse>(`/purchases/orders/${orderNumber}/status/`);
            return data;
        },
        refetchInterval: 1000, // Перезапрос каждые 3 секунды
        enabled: !!orderNumber, 
    });
};

export default useGetOrderStatus;